const CREATE_STORY_INFO = '/create/story/info';
const CREATE_SCENE_INFO = '/create/scene/info';
const MISSION_BASE = '/create/mission';
const CREATE_MISSION_INFO = `${MISSION_BASE}/:type/:misId?`;
const MISSION_INFO = '/create/mission/info';
const MISSION_LIST = '/create/mission/list';

const PUBLISH_BASE = '/create/publish';

const CREATE_BOT_INFO = '/bot/info';
const CREATE_PROPS_INFO = '/props/info';

export const MISSION_TYPE = {
  INFO: 'info',
  LIST: 'list',
};

const SPACE_LIST = '/list/space';
const BOT_LIST = '/list/bot';

const STORY_LIST = '/list/story';
const PROPS_LIST = '/list/props';

const UGC_STORY_LIST = '/studio/list/story';
const UGC_BOT_LIST = '/studio/list/bot';

const UGC_NOVEL_LIST = '/studio/list/novel';

const LOGIN_TEST = '/loginTest';
const CONTRACT = '/contract';

const BASE_NAME = '/';

const TOOL = '/tool';

const IMAGE_EDIT = '/imageEdit';

// home
const STUDIO_HOME = '/studio';

const WEB_ADMIN_HOME = `${STUDIO_HOME}`;

// manage
const MANAGE = '/manage';
const PROMOTION = 'promotion';
const PLAZA = 'plaza';
const MATERIAL = '/material';
const MANAGE_SPACE_LIST = `${MANAGE}/list/space`;
const MANAGE_PROMOTION_LIST = `${MANAGE}/list/promotion`;
const MANAGE_PLAZA_LIST = `${MANAGE}/list/plaza`;
const MANAGE_MATERIAL_LIST = `${MANAGE}/list/material`;
const CREATE_SPACE_INFO = `${MANAGE}/space/info`;
const CREATE_PROMOTION_INFO = `${MANAGE}/promotion/info`;
const CREATE_PLAZA_INFO = `${MANAGE}/plaza/info`;
const CREATE_MATERIAL_INFO = `${MANAGE}/material/info`;
const NOVEL_TOOL = `${MANAGE}/novel/tool`;
const NOVEL_HOME_LIST = `${MANAGE}/novel/home/list`;
const NOVEL_HOME_INFO = `${MANAGE}/novel/home`;
const NOVEL_CONFIG = `${MANAGE}/novel/config`;
const AI_TOWN_EDITOR = `${MANAGE}/aiTown/editor`;
const UI = 'ui/home';

const EDITOR = '/studio/editor';
const STORYLINE = '/studio/storyline';

// picBook
const PICBOOK_LOWER = 'picbook';
const PIC_BOOK_HOME = '/picBook/home';
const PIC_BOOK_EDITOR = '/picBook/editor';
const PIC_BOOK_TEXT_LIST = '/picBook/list/text';
const PIC_BOOK_IMAGE_LIST = '/picBook/list/image';

export {
  AI_TOWN_EDITOR,
  BASE_NAME, BOT_LIST, CONTRACT,
  CREATE_BOT_INFO, CREATE_MATERIAL_INFO, CREATE_MISSION_INFO,
  CREATE_PLAZA_INFO, CREATE_PROMOTION_INFO,
  CREATE_PROPS_INFO, CREATE_SCENE_INFO,
  CREATE_SPACE_INFO, CREATE_STORY_INFO,
  EDITOR, IMAGE_EDIT, LOGIN_TEST,
  MANAGE, MANAGE_MATERIAL_LIST, MANAGE_PLAZA_LIST, MANAGE_PROMOTION_LIST,
  MANAGE_SPACE_LIST, MATERIAL,
  MISSION_BASE, MISSION_INFO, MISSION_LIST,
  NOVEL_CONFIG, NOVEL_HOME_INFO, NOVEL_HOME_LIST, NOVEL_TOOL, PIC_BOOK_EDITOR, PIC_BOOK_HOME,
  PIC_BOOK_IMAGE_LIST, PIC_BOOK_TEXT_LIST,
  PICBOOK_LOWER,
  PLAZA, PROMOTION, PROPS_LIST,
  PUBLISH_BASE,
  SPACE_LIST,
  STORY_LIST, STORYLINE, STUDIO_HOME, TOOL, UGC_BOT_LIST, UGC_NOVEL_LIST, UGC_STORY_LIST, UI, WEB_ADMIN_HOME,
};

